import React from 'react';
import PropTypes from 'prop-types';
import A11ySvg from 'components/A11ySvg';
import './CommentIcon.css';

function CommentIcon({
  className,
  size = 'base',
  title,
  alt,
  filled,
  disabled
}) {
  const setClassName = `comment-icon ${className || ''} ${size} ${
    filled ? ' filled' : ''
  }${disabled ? ' disabled' : ''}`;
  return (
    <A11ySvg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 16"
      className={setClassName}
      title={title}
      alt={alt}
    >
      <mask id="path-1-inside-1_762_1300" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.826 12.1694C19.1868 10.8882 20 9.26534 20 7.5C20 3.35786 15.5228 0 10 0C4.47715 0 0 3.35786 0 7.5C0 11.6421 4.47715 15 10 15C11.8962 15 13.6692 14.6042 15.18 13.9167L17.575 15.1762C17.9458 15.3712 18.3776 15.0512 18.2988 14.6397L17.826 12.1694Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.826 12.1694C19.1868 10.8882 20 9.26534 20 7.5C20 3.35786 15.5228 0 10 0C4.47715 0 0 3.35786 0 7.5C0 11.6421 4.47715 15 10 15C11.8962 15 13.6692 14.6042 15.18 13.9167L17.575 15.1762C17.9458 15.3712 18.3776 15.0512 18.2988 14.6397L17.826 12.1694Z"
        fill="#E6ECFF"
      />
      <path
        d="M17.826 12.1694L17.1405 11.4413L16.7405 11.8179L16.8438 12.3574L17.826 12.1694ZM15.18 13.9167L15.6454 13.0316L15.2118 12.8035L14.7658 13.0065L15.18 13.9167ZM17.575 15.1762L17.1095 16.0613L17.1095 16.0613L17.575 15.1762ZM18.2988 14.6397L19.281 14.4517L19.281 14.4517L18.2988 14.6397ZM19 7.5C19 8.94026 18.3396 10.3123 17.1405 11.4413L18.5115 12.8975C20.0339 11.4641 21 9.59042 21 7.5H19ZM10 1C12.566 1 14.8505 1.7813 16.4711 2.9967C18.0913 4.21186 19 5.81426 19 7.5H21C21 5.0436 19.6701 2.896 17.6711 1.3967C15.6723 -0.102372 12.9569 -1 10 -1V1ZM1 7.5C1 5.81426 1.90871 4.21186 3.52893 2.9967C5.14946 1.7813 7.43402 1 10 1V-1C7.04313 -1 4.32769 -0.102372 2.32893 1.3967C0.329863 2.896 -1 5.0436 -1 7.5H1ZM10 14C7.43402 14 5.14946 13.2187 3.52893 12.0033C1.90871 10.7881 1 9.18574 1 7.5H-1C-1 9.9564 0.329863 12.104 2.32893 13.6033C4.32769 15.1024 7.04313 16 10 16V14ZM14.7658 13.0065C13.3898 13.6326 11.7587 14 10 14V16C12.0337 16 13.9485 15.5757 15.5941 14.8269L14.7658 13.0065ZM18.0405 14.2912L15.6454 13.0316L14.7145 14.8017L17.1095 16.0613L18.0405 14.2912ZM17.3166 14.8277C17.2379 14.4163 17.6697 14.0962 18.0405 14.2912L17.1095 16.0613C18.2218 16.6463 19.5173 15.686 19.281 14.4517L17.3166 14.8277ZM16.8438 12.3574L17.3166 14.8277L19.281 14.4517L18.8081 11.9814L16.8438 12.3574Z"
        fill="#546177"
        fillOpacity="0.6"
        mask="url(#path-1-inside-1_762_1300)"
      />
      <line
        x1="6.5"
        y1="4.5"
        x2="13.5"
        y2="4.5"
        stroke="#546177"
        strokeLinecap="round"
      />
      <line
        x1="6.5"
        y1="7.5"
        x2="13.5"
        y2="7.5"
        stroke="#546177"
        strokeLinecap="round"
      />
      <line
        x1="6.5"
        y1="10.5"
        x2="13.5"
        y2="10.5"
        stroke="#546177"
        strokeLinecap="round"
      />
    </A11ySvg>
  );
}

CommentIcon.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string.isRequired,
  filled: PropTypes.bool,
  disabled: PropTypes.bool
};

export default CommentIcon;
